import React, { useState, useEffect } from 'react';
import './PhoneCarousel.scss';

const PhoneCarousel: React.FC = () => {
  const [currentImage, setCurrentImage] = useState(0);
  
  const images = [
    '/images/Dashboard – all on stationary mode – 1.png',
    '/images/Live tracking-view stationary mode tracker.png',
    '/images/Precise Live tracking - tracker journey.png',
    '/images/Toggle tracker list view.png',
    '/images/Movement Mode.png',
    '/images/Battery page – battery health page.png'
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentImage((prev) => (prev + 1) % images.length);
    }, 10000);
    return () => clearInterval(interval);
  }, [images.length]);

  const nextImage = () => {
    setCurrentImage((prev) => (prev + 1) % images.length);
  };

  const prevImage = () => {
    setCurrentImage((prev) => (prev - 1 + images.length) % images.length);
  };

  return (
    <section className="phone-carousel">
      <div className="container">
        <div className="phone-content">
          <img src="/logo-black.svg" alt="Shadow Logo" className="shadow-logo" />
          <div className="phone-wrapper">
            <button className="nav-btn prev-btn" onClick={prevImage}>
              ‹
            </button>
            <div className="iphone-17-pro-max">
              <div className="phone-frame">
                <div className="dynamic-island"></div>
                <div className="screen">
                  <div className="carousel-container">
                    {images.map((image, index) => (
                      <img
                        key={index}
                        src={image}
                        alt={`Shadow tracker app view ${index + 1}`}
                        className={`carousel-image ${index === currentImage ? 'active' : ''}`}
                      />
                    ))}
                  </div>
                </div>
              </div>
            </div>
            <button className="nav-btn next-btn" onClick={nextImage}>
              ›
            </button>
          </div>
          <div className="content-section">
            <h2 className="main-title">Shadow Track Application</h2>
            <p className="subtitle">
              The Shadow Track application allows you to track and manage all your assets 
              with precision and ease. Monitor your vehicles, equipment, and valuables 
              in real-time with our advanced stealth tracking technology.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PhoneCarousel;
